const state = {
  isIntro: true,
  highlight: '',
  positionArr: [
    {
      top: 125,
      left: 241
    },
    {
      top: 280,
      left: 500
    }
  ]
}

const actions = {}

const mutations = {}

export default {
  state,
  actions,
  mutations
}
